import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DecisionModalComponent } from 'modules/shared/decision-modal/decision-modal.component';
import { ButtonComponent } from 'modules/shared/button/button.component';
import { BasicChartComponent } from './basic-chart/basic-chart.component';

@NgModule({
  declarations: [
    DecisionModalComponent,
    ButtonComponent,
    BasicChartComponent
  ],
  exports: [
    ButtonComponent,
    BasicChartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatDialogModule,
    MatIconModule,
  ],
  entryComponents: [
    DecisionModalComponent,
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
  ],
})
export class SharedModule { }
